module.exports = __webpack_public_path__ + "img/background.9b3a54af.jpg";